var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 23.667C11.4526 23.667 10.9993 23.2136 10.9993 22.667V17.0803L10.0393 18.0403C9.6526 18.427 9.0126 18.427 8.62594 18.0403C8.23927 17.6536 8.23927 17.0136 8.62594 16.627L11.2926 13.9603C11.5726 13.6803 12.0126 13.587 12.3859 13.747C12.7593 13.8936 12.9993 14.267 12.9993 14.667V22.667C12.9993 23.2136 12.5459 23.667 11.9993 23.667Z",
    fill: "#8B8699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6672 18.3333C14.4139 18.3333 14.1606 18.2399 13.9606 18.0399L11.2939 15.3733C10.9072 14.9866 10.9072 14.3466 11.2939 13.9599C11.6806 13.5733 12.3206 13.5733 12.7072 13.9599L15.3739 16.6266C15.7606 17.0133 15.7606 17.6533 15.3739 18.0399C15.1739 18.2399 14.9206 18.3333 14.6672 18.3333Z",
    fill: "#8B8699"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0013 30.3337H12.0013C4.7613 30.3337 1.66797 27.2403 1.66797 20.0003V12.0003C1.66797 4.76033 4.7613 1.66699 12.0013 1.66699H18.668C19.2146 1.66699 19.668 2.12033 19.668 2.66699C19.668 3.21366 19.2146 3.66699 18.668 3.66699H12.0013C5.85464 3.66699 3.66797 5.85366 3.66797 12.0003V20.0003C3.66797 26.147 5.85464 28.3337 12.0013 28.3337H20.0013C26.148 28.3337 28.3346 26.147 28.3346 20.0003V13.3337C28.3346 12.787 28.788 12.3337 29.3346 12.3337C29.8813 12.3337 30.3346 12.787 30.3346 13.3337V20.0003C30.3346 27.2403 27.2413 30.3337 20.0013 30.3337Z",
    fill: "#8B8699"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3346 14.3336H24.0013C19.4413 14.3336 17.668 12.5603 17.668 8.00031V2.66698C17.668 2.26698 17.908 1.89364 18.2813 1.74698C18.6546 1.58698 19.0813 1.68031 19.3746 1.96031L30.0413 12.627C30.3213 12.907 30.4146 13.347 30.2546 13.7203C30.0946 14.0936 29.7346 14.3336 29.3346 14.3336ZM19.668 5.08031V8.00031C19.668 11.4403 20.5613 12.3336 24.0013 12.3336H26.9213L19.668 5.08031Z",
    fill: "#8B8699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadfile);
export default __webpack_public_path__ + "static/media/uploadfile.2f22d814.svg";
export { ForwardRef as ReactComponent };